import s from '../s';
import {readPreloadHeading} from './product-header-title';

/**
 * The product page H1 (portals 0 to 2): the server's heading when the page carries one (the shell showed it before mount), else the
 * store's manual override, else the institution name (where the product shows it) and the product title. Both layouts render it.
 */
export function productHeadingText(): string {
    const showInstInProductH1 = s.prod && !s.prod.IsCAF && s.prod.TitleShowInstName && !s.si.hide_prod_page_inst_h1;
    const useManualOverride = !!(s.si.ManualOverride_Desc && s.si.ManualOverride_Desc.length > 5);
    return readPreloadHeading() ?? (useManualOverride ? s.si.ManualOverride_Desc : `${showInstInProductH1 ? `${s.si.InstName} ` : ''}${s.ui.product_title}`);
}
